// "use client"

// import { useState } from "react"
// import Image, { type ImageProps } from "next/image"
// import { cn } from "@/lib/utils"

// interface ImageWithFallbackProps extends Omit<ImageProps, "onError"> {
//   fallbackSrc?: string
//   className?: string
// }

// export default function ImageWithFallback({
//   src,
//   fallbackSrc = "/placeholder.svg?height=600&width=800",
//   alt,
//   className,
//   ...rest
// }: ImageWithFallbackProps) {
//   const [imgSrc, setImgSrc] = useState(src)
//   const [isLoading, setIsLoading] = useState(true)

//   return (
//     <div className={cn("relative", className)}>
//       {isLoading && <div className="absolute inset-0 bg-muted animate-pulse rounded-lg" />}
//       <Image
//         {...rest}
//         src={imgSrc || "/placeholder.svg"}
//         alt={alt}
//         className={cn("transition-opacity duration-300", isLoading ? "opacity-0" : "opacity-100", className)}
//         onError={() => setImgSrc(fallbackSrc)}
//         onLoad={() => setIsLoading(false)}
//       />

//     </div>
//   )
// }

"use client"

import { useState } from "react"
import Image, { type ImageProps } from "next/image"
import { cn } from "@/lib/utils"

interface ImageWithFallbackProps extends Omit<ImageProps, "onError"> {
  fallbackSrc?: string
  className?: string
}

export default function ImageWithFallback({
  src,
  fallbackSrc = "/placeholder.svg",
  alt,
  className,
  ...rest
}: ImageWithFallbackProps) {
  const [imgSrc, setImgSrc] = useState(src)
  const [isLoading, setIsLoading] = useState(true)

  return (
    <div className={cn("relative", className)}>
      {isLoading && <div className="absolute inset-0 bg-muted animate-pulse rounded-lg" />}
      <Image
        {...rest}
        src={imgSrc || fallbackSrc}
        alt={alt || "Image"}
        className={cn("transition-opacity duration-300", isLoading ? "opacity-0" : "opacity-100", className)}
        onError={() => {
          setImgSrc(fallbackSrc)
        }}
        onLoad={() => setIsLoading(false)}
      />
    </div>
  )
}